import { render, staticRenderFns } from "./NewFolderModal.vue?vue&type=template&id=655aaee0&scoped=true&"
import script from "./NewFolderModal.vue?vue&type=script&lang=ts&"
export * from "./NewFolderModal.vue?vue&type=script&lang=ts&"
import style0 from "./NewFolderModal.vue?vue&type=style&index=0&id=655aaee0&prod&scoped=true&lang=css&"
import style1 from "./NewFolderModal.vue?vue&type=style&index=1&id=655aaee0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655aaee0",
  null
  
)

export default component.exports